import { Injectable } from '@angular/core';
import { RentalCar } from '../business-entities/rental-car.interface';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';
import { RentalCarDataService } from '../data-services/rental-car-data.Service';

@Injectable({
    providedIn: 'root'
})

export class RentalCarService {
    dealerId: string;
    isEdit: boolean = false;
    RentalCarId: number
    isAdd: boolean = false;
    dealerList: Array<SelectListItemViewModel>;

    constructor(private service: RentalCarDataService) {
    }

    GetRentalCarList(dealerId: string,status: number): Promise<any> {
        return this.service.GetRentalCarList(dealerId,status);
    }

    AddRentalCar(rentalCar: RentalCar) {

        return this.service.AddRentalCar(rentalCar);
    }

    GetRentalCarById(Id: number) {
        return this.service.GetRentalCarById(Id);
    }


    GetFuelTypes(): Promise<any> {
        return this.service.GetFuelTypes();
    }

    EditRentalCar(editRentalCar: RentalCar) {
        return this.service.EditRentalCar(editRentalCar);
    }
    DeleteRentalCar(rentalCarId: number) {
        return this.service.DeleteRentalCar(rentalCarId);
    }
    GetAllBrand(): Promise<any> {
        return this.service.GetAllBrand();
    }
    GetAllVehicleStatus(): Promise<any> {
        return this.service.GetAllVehicleStatus();
    }

}